module.exports = __webpack_public_path__ + "media/images/about-fa82cc66967bbc17874a2b784b695498.png";